// TODO: REFACTORING
import React, { Component } from 'react';
import { navigate } from 'gatsby';
import { isLoggedIn, isBrowser } from '../../services/auth';
import { getCookie } from '@utils/cookies.helper';

const PrivateRoute = ({ component: Component, location, ...rest }) => {
  if (!isLoggedIn() && isBrowser()) {
    const locale = getCookie('NEXT_LOCALE');
    navigate(`/${locale ? locale : ''}`);
    return null;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
